import type { PointLoungePageConfig } from '@/app/(football)/[team]/point-lounge/_context/types';

export const uhdfcConfig: PointLoungePageConfig = {};
